import React from "react";
import { Flex, Text, TextField } from "@radix-ui/themes";

export function SevenRoomsClientTagSection({
  tagGroup,
  tagName,
  onTagGroupChange,
  onTagNameChange,
  disabled = false,
}) {
  const preview = tagGroup.trim() && tagName.trim()
    ? `${tagGroup.trim()}:${tagName.trim()}`
    : "";
  const isIncomplete = Boolean(tagGroup.trim()) !== Boolean(tagName.trim());

  return (
    <Flex direction="column" gap="3">
      <Text size="1" color="gray">
        Optional. First create this client tag in SevenRooms, then enter its exact group and
        tag names here. b connect applies it after creating a client and whenever an existing
        client is updated.
      </Text>
      <Flex gap="3" wrap="wrap">
        <Flex direction="column" gap="1" style={{ flex: "1 1 220px" }}>
          <Text size="2" weight="medium" as="label">
            Tag group / source name
          </Text>
          <TextField.Root
            value={tagGroup}
            onChange={(event) => onTagGroupChange(event.target.value)}
            placeholder="e.g. BCONNECT"
            disabled={disabled}
            size="2"
          />
        </Flex>
        <Flex direction="column" gap="1" style={{ flex: "1 1 220px" }}>
          <Text size="2" weight="medium" as="label">
            Tag name
          </Text>
          <TextField.Root
            value={tagName}
            onChange={(event) => onTagNameChange(event.target.value)}
            placeholder="e.g. bWiFi"
            disabled={disabled}
            size="2"
          />
        </Flex>
      </Flex>
      {preview && (
        <Text size="1" color="gray">
          SevenRooms value: {preview}
        </Text>
      )}
      {isIncomplete && (
        <Text size="1" color="red">
          Enter both the tag group/source name and tag name, or leave both empty.
        </Text>
      )}
    </Flex>
  );
}

export function SevenRoomsRequiredFieldsNotice() {
  return (
    <Flex
      direction="column"
      gap="1"
      style={{
        padding: "var(--space-3)",
        borderRadius: "var(--radius-2)",
        background: "var(--amber-a3)",
        border: "1px solid var(--amber-a6)",
      }}
    >
      <Text size="2" weight="medium">
        Required client identifier
      </Text>
      <Text size="1" color="gray">
        To create or match a SevenRooms client, the contact must have an Email address or Phone
        number. First name and Last name are sent when available and otherwise created as blank.
        Contacts missing both identifiers are skipped.
      </Text>
    </Flex>
  );
}
